// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3eBIQ","rootSuccess":"CompleteLink_rootSuccess__2gXTd","rootFailure":"CompleteLink_rootFailure__q2djB","isDisabled":"CompleteLink_isDisabled__1Kyc4"};